<div class="wrapper">
    <mat-spinner style="margin: 12em auto"></mat-spinner>
</div>
